"use client";

type ConfirmPopUpProps = {
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    isConfirming?: boolean;
};

export default function ConfirmPopUp({
    title,
    message,
    confirmText = "ยืนยัน",
    cancelText = "ยกเลิก",
    onConfirm,
    onCancel,
    isConfirming = false,
}: ConfirmPopUpProps) {
    return (
        <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/45 p-4">
            <div className="w-full max-w-100 rounded-md bg-[#f3f3f3] px-5 pb-8 pt-7 shadow-[0_6px_20px_rgba(0,0,0,0.35)]">
                <div className="mx-auto w-70 rounded-sm border border-[#FDEF5C] bg-[#FDEF5C] py-1 text-center text-lg font-semibold text-[#2B2B2B] shadow-[4px_4px_0_#5d6670]">
                    {title}
                </div>

                <p className="mt-6 text-center text-base text-[#4E4E4E]">{message}</p>

                <div className="mt-7 flex justify-center gap-4">
                    <button
                        type="button"
                        onClick={onCancel}
                        disabled={isConfirming}
                        className="min-w-20 cursor-pointer rounded-md border border-[#c4c4c4] bg-white px-7 py-2 text-base font-semibold text-[#4E4E4E] disabled:cursor-not-allowed disabled:opacity-70"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isConfirming}
                        className="min-w-20 cursor-pointer rounded-md bg-[#0a9cf0] px-7 py-2 text-base font-semibold text-white disabled:cursor-not-allowed disabled:opacity-70 hover:bg-[#0784b9]"
                    >
                        {isConfirming ? "กำลังบันทึก..." : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
